<template>
  <div v-if="isShow" class="preview" @click="close">
    <!-- 这里只能用v-if mt-swipe会有缓存 -->
    <div id="goods_preview" class="preview__content">
      <mt-swipe :auto="0" :continuous="false" :defaultIndex="defaultImgIndx" :showIndicators="false"
                @change="getImgIndex">
        <mt-swipe-item v-for="(item,index) in images" :key="index">
          <img :src="item">
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <span class="preview__img-index">{{ showIndex }}</span>
  </div>
</template>
<script>


export default {
  props: ['isShow', 'defaultIndex', 'images'],
  data() {
    return {
      defaultImgIndx: 0,
    };
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          this.defaultImgIndx = this.defaultIndex;
          setTimeout(() => {
            const { Pic } = window;
            const pic = new Pic('#goods_preview');
            pic.picInit();
          }, 500);
        }
      },
      immediate: true,
    },
  },
  computed: {
    showIndex() {
      const {
        defaultImgIndx,
        images,
      } = this;
      if (Array.isArray(images) && images.length) {
        return `${defaultImgIndx + 1}/${images.length}`;
      }
      return '';
    },
  },
  methods: {
    close() {
      this.$emit('close', this.defaultImgIndx);
    },
    getImgIndex(index) {
      this.defaultImgIndx = index;
    },
  },
};
</script>
<style lang="scss">
.preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4000;
  background: rgba(135, 135, 135, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    width: 100%;
    height: 60%;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .mint-swipe-items-wrap {
    background: rgba(135, 135, 135, 0);
  }

  .mint-swipe-item {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  &__img-index {
    position: absolute;
    right: 45%;
    bottom: 13%;
    /*background: #ff5f00;*/
    border-radius: 19px;
    padding: 4px 20px;
    color: #fff;
    font-size: 24px;
  }
}
</style>
